import Axios from "axios";
import {
  ADMIN_ANSWER_QNA_FAIL,
  ADMIN_ANSWER_QNA_REQUEST,
  ADMIN_ANSWER_QNA_SUCCESS,
  ADMIN_LIST_QNA_FAIL,
  ADMIN_LIST_QNA_REQUEST,
  ADMIN_LIST_QNA_SUCCESS,
  CREATE_QNA_FAIL,
  CREATE_QNA_REQUEST,
  CREATE_QNA_SUCCESS,
  LIST_QNA_FAIL,
  LIST_QNA_REQUEST,
  LIST_QNA_SUCCESS,
} from "../constants/qnaConstants";

//POST A REQUEST TO CREATE QNA
export const actionToCreateQna = (qnaDetails) => async (dispatch) => {
  dispatch({ type: CREATE_QNA_REQUEST });

  try {
    const { data } = await Axios.post(`/api/qna/create`, qnaDetails);
    dispatch({ type: CREATE_QNA_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: CREATE_QNA_FAIL, payload: message });
  }
};

// ADMIN GET QNA LIST
export const actionAdminToListQnas =
  (value, keyword = "", pageNumber = "") =>
  async (dispatch, getState) => {
    dispatch({ type: ADMIN_LIST_QNA_REQUEST });
    const {
      adminUserToLogin: { adminUserInfo },
    } = getState();
    try {
      const { data } = await Axios.get(
        `/api/qna/adminlist?type=${value}&keyword=${keyword}&pageNumber=${pageNumber}`,
        {
          headers: { Authorization: `Bearer ${adminUserInfo?.token}` },
        }
      );
      dispatch({ type: ADMIN_LIST_QNA_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: ADMIN_LIST_QNA_FAIL, payload: message });
    }
  };

//ADMIN POST A REQUEST TO ANSWER QNA
export const actionAdminToAnswerQna =
  (answer) => async (dispatch, getState) => {
    dispatch({ type: ADMIN_ANSWER_QNA_REQUEST });
    const {
      adminUserToLogin: { adminUserInfo },
    } = getState();
    try {
      const { data } = await Axios.post(`/api/qna/adminanswer`, answer, {
        headers: { Authorization: `Bearer ${adminUserInfo?.token}` },
      });
      dispatch({ type: ADMIN_ANSWER_QNA_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: ADMIN_ANSWER_QNA_FAIL, payload: message });
    }
  };

// VISITOR GET QNA LIST
export const actionListQnas = (productId, qnaCount) => async (dispatch) => {
  dispatch({ type: LIST_QNA_REQUEST });

  try {
    const { data } = await Axios.get(`/api/qna/list/${productId}/${qnaCount}`);
    dispatch({ type: LIST_QNA_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: LIST_QNA_FAIL, payload: message });
  }
};
